'use client';
import React from 'react';

import Error from '@shaojiang/components/Error';

export default function ErrorPage() {
  return <Error />;
}
